(function () {
  'use strict';
  var doc = document;
  var root = doc.documentElement;
  var R = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (R.charAt(R.length - 1) !== '/') R += '/';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Decorative idle motion waits until the page has loaded and gone quiet. */
  function gate() {
    setTimeout(function () {
      root.dataset.motion = 'on';
    }, 1200);
  }
  if (doc.readyState === 'complete') gate();
  else window.addEventListener('load', gate, { once: true });

  /* Sniffy's LED eyes follow the pointer. */
  var faces = [].slice.call(doc.querySelectorAll('[data-sniffy-face]'));
  if (faces.length && !reduce) {
    var raf = 0;
    window.addEventListener(
      'pointermove',
      function (e) {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          faces.forEach(function (face) {
            var r = face.getBoundingClientRect();
            if (!r.width) return;
            var dx = e.clientX - (r.left + r.width / 2);
            var dy = e.clientY - (r.top + r.height / 2);
            var d = Math.hypot(dx, dy) || 1;
            var reach = Math.min(1, d / 180);
            face.style.setProperty('--px', ((dx / d) * reach * 7).toFixed(2) + 'px');
            face.style.setProperty('--py', ((dy / d) * reach * 5).toFixed(2) + 'px');
          });
        });
      },
      { passive: true }
    );
  }

  /* Gentle scroll-in: a short fade, triggered a screen early, always un-hides after 1.5s. */
  [].slice.call(doc.querySelectorAll('.reveal')).forEach(function (el) {
    if (reduce || !('IntersectionObserver' in window)) return;
    if (el.getBoundingClientRect().top < window.innerHeight * 1.1) return;
    var safety;
    var io = new IntersectionObserver(
      function (entries) {
        if (entries.some(function (x) { return x.isIntersecting; })) show();
      },
      { rootMargin: '0px 0px 100% 0px' }
    );
    function show() {
      el.dataset.hidden = 'false';
      io.disconnect();
      clearTimeout(safety);
    }
    el.dataset.hidden = 'true';
    io.observe(el);
    safety = setTimeout(show, 1500);
  });

  /* Gallery: arrows and thumbnails inside each [data-gallery] block. */
  [].slice.call(doc.querySelectorAll('[data-gallery]')).forEach(function (g) {
    var panels = [].slice.call(g.querySelectorAll('[data-panel]'));
    var thumbs = [].slice.call(g.querySelectorAll('[data-thumb]'));
    var current = 0;
    function go(i) {
      if (!panels.length) return;
      current = (i + panels.length) % panels.length;
      panels.forEach(function (p, n) { p.hidden = n !== current; });
      thumbs.forEach(function (t, n) {
        var on = n === current;
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        t.classList.toggle('border-ink', on);
        t.classList.toggle('shadow-soft', on);
        t.classList.toggle('border-transparent', !on);
        t.classList.toggle('opacity-80', !on);
      });
    }
    [].slice.call(g.querySelectorAll('[data-gallery-step]')).forEach(function (b) {
      b.addEventListener('click', function () { go(current + Number(b.dataset.galleryStep)); });
    });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(Number(t.dataset.thumb)); });
    });
    // Swipe left or right on the photo (mostly horizontal moves only, so page scrolling still works).
    var sx = null;
    var sy = null;
    g.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      sx = t.clientX;
      sy = t.clientY;
    }, { passive: true });
    g.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx;
      var dy = t.clientY - sy;
      sx = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) go(current + (dx < 0 ? 1 : -1));
    }, { passive: true });
    g.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(current + 1);
      else if (e.key === 'ArrowLeft') go(current - 1);
    });
  });

  /* Bundle selector: switches the variant, price and gallery. */
  var form = doc.querySelector('[data-buy-form]');
  if (form) {
    var variantInput = form.querySelector('[data-variant-input]');
    var priceEl = doc.querySelector('[data-price]');
    var eachEl = doc.querySelector('[data-each]');
    [].slice.call(form.querySelectorAll('[data-bundle]')).forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        variantInput.value = r.dataset.variant;
        if (priceEl) priceEl.textContent = r.dataset.price;
        if (eachEl) eachEl.hidden = r.dataset.isDuo !== 'true';
        [].slice.call(doc.querySelectorAll('[data-box-single]')).forEach(function (li) { li.hidden = r.dataset.isDuo === 'true'; });
        [].slice.call(doc.querySelectorAll('[data-box-duo]')).forEach(function (li) { li.hidden = r.dataset.isDuo !== 'true'; });
        [].slice.call(doc.querySelectorAll('[data-gallery]')).forEach(function (g) {
          g.hidden = g.dataset.gallery !== r.dataset.galleryHandle;
        });
      });
    });
    var qty = form.querySelector('[data-qty]');
    if (qty) {
      var clampQty = function () {
        var n = parseInt(qty.value, 10);
        qty.value = Math.min(10, Math.max(1, n > 0 ? n : 1));
      };
      qty.addEventListener('change', clampQty);
      qty.addEventListener('blur', clampQty);
    }
    [].slice.call(form.querySelectorAll('[data-qty-step]')).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = Math.min(10, Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.dataset.qtyStep)));
        qty.value = n;
      });
    });
  }

  /* Add to cart (product form and quick-add forms): add, show the tick, then open the cart page. */
  [].slice.call(doc.querySelectorAll('[data-buy-form], [data-quick-add]')).forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = f.querySelector('[data-atc]');
      if (btn && btn.disabled) return;
      var data = new FormData(f);
      var qtyValue = Math.min(10, Math.max(1, parseInt(data.get('quantity'), 10) || 1));
      var body = { id: Number(data.get('id')), quantity: qtyValue };
      var errEl = f.querySelector('[data-atc-error]');
      var showError = function (msg) {
        if (!errEl) {
          errEl = doc.createElement('p');
          errEl.setAttribute('data-atc-error', '');
          errEl.setAttribute('role', 'alert');
          errEl.className = 'mt-3 text-sm font-medium text-orange-deep';
          f.appendChild(errEl);
        }
        errEl.hidden = false;
        errEl.textContent = msg;
      };
      if (errEl) errEl.hidden = true;
      if (btn) btn.disabled = true;
      fetch(R + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (res) {
          if (res.ok) {
            if (btn) {
              btn.disabled = false;
              btn.dataset.state = 'added';
            }
            var status = f.querySelector('[data-atc-status]');
            if (status) status.textContent = 'Added to your cart.';
            setTimeout(function () { window.location.href = R + 'cart'; }, 800);
            return;
          }
          // The store answered with an error (for example the item can't be added right now): say so on the page.
          return res.json().then(
            function (j) { return j.description || j.message || ''; },
            function () { return ''; }
          ).then(function (detail) {
            if (btn) btn.disabled = false;
            showError('Sorry, we couldn’t add that to your cart.' + (detail ? ' ' + detail : '') + ' Please try again, or contact us if it keeps happening.');
          });
        })
        .catch(function () {
          // Network problem: fall back to the normal form post.
          if (btn) btn.disabled = false;
          f.submit();
        });
    });
  });

  /* Cart upsell: swap the single Sniffy for a Desk Duo. */
  [].slice.call(doc.querySelectorAll('[data-upsell]')).forEach(function (b) {
    b.addEventListener('click', function () {
      b.disabled = true;
      fetch(R + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(b.dataset.duoVariant), quantity: 1 }),
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          return fetch(R + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: b.dataset.lineKey, quantity: 0 }),
          });
        })
        .then(function () { window.location.reload(); })
        .catch(function () {
          b.disabled = false;
          var note = b.parentNode.querySelector('[data-upsell-error]');
          if (!note) {
            note = doc.createElement('p');
            note.setAttribute('data-upsell-error', '');
            note.setAttribute('role', 'alert');
            note.className = 'mt-2 text-sm text-ink-soft';
            b.parentNode.appendChild(note);
          }
          note.textContent = 'Sorry, we couldn’t switch to the Desk Duo. Your Sniffy is still in your cart.';
        });
    });
  });

  /* Cart: changing a quantity updates the cart (the Update cart button stays as a fallback). */
  [].slice.call(doc.querySelectorAll('[data-cart-qty]')).forEach(function (input) {
    var timer;
    input.addEventListener('change', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var f = input.form;
        var update = f && f.querySelector('[name="update"]');
        if (f && f.requestSubmit) f.requestSubmit(update);
        else if (f) f.submit();
      }, 450);
    });
  });

  /* Open the FAQ answer that a link points to (for example the "Track your order" link in the footer). */
  var openFromHash = function () {
    var id = window.location.hash.slice(1);
    if (!id) return;
    var el = doc.getElementById(id);
    if (el && el.tagName === 'DETAILS') {
      el.open = true;
      el.scrollIntoView({ block: 'start' });
    }
  };
  window.addEventListener('hashchange', openFromHash);
  openFromHash();

  /* Mobile sticky buy bar: appears once the buy section has scrolled out above the viewport. */
  var bar = doc.querySelector('[data-sticky-bar]');
  var buy = doc.getElementById('buy');
  if (bar && buy && 'IntersectionObserver' in window) {
    var link = bar.querySelector('[data-sticky-link]');
    new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var show = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      bar.classList.toggle('translate-y-0', show);
      bar.classList.toggle('translate-y-full', !show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      link.setAttribute('tabindex', show ? '0' : '-1');
    }).observe(buy);
  }

  /* Slide-out menu: native modal dialog (focus trap, inert page), animated open and close. */
  var drawer = doc.querySelector('[data-menu-drawer]');
  var opener = doc.querySelector('[data-menu-open]');
  if (drawer && opener && typeof drawer.showModal === 'function') {
    var closing = false;
    var openMenu = function () {
      if (drawer.open) return;
      drawer.removeAttribute('data-closing');
      drawer.showModal();
      opener.setAttribute('aria-expanded', 'true');
      var first = drawer.querySelector('[data-menu-close]');
      if (first) first.focus();
    };
    var closeMenu = function () {
      if (!drawer.open || closing) return;
      closing = true;
      drawer.setAttribute('data-closing', '');
      setTimeout(function () {
        drawer.close();
        drawer.removeAttribute('data-closing');
        closing = false;
      }, reduce ? 0 : 220);
    };
    opener.addEventListener('click', openMenu);
    [].slice.call(drawer.querySelectorAll('[data-menu-close]')).forEach(function (b) { b.addEventListener('click', closeMenu); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) closeMenu(); });
    drawer.addEventListener('cancel', function (e) { e.preventDefault(); closeMenu(); });
    drawer.addEventListener('close', function () { opener.setAttribute('aria-expanded', 'false'); opener.focus(); });
    [].slice.call(drawer.querySelectorAll('[data-menu-link]')).forEach(function (a) {
      a.addEventListener('click', function () {
        // Same-page anchors keep the page open, so close the menu first.
        if (a.getAttribute('href').indexOf('#') > -1) closeMenu();
      });
    });
  }

  /* Nozzle clip pause / play. */
  [].slice.call(doc.querySelectorAll('[data-clip-toggle]')).forEach(function (b) {
    b.addEventListener('click', function () {
      var clip = b.closest('[data-clip]');
      var paused = clip.dataset.paused !== 'true';
      clip.dataset.paused = paused ? 'true' : 'false';
      b.setAttribute('aria-pressed', paused ? 'true' : 'false');
      b.textContent = paused ? 'Play animation' : 'Pause animation';
    });
  });
})();
